import { render, staticRenderFns } from "./AllElderAge.vue?vue&type=template&id=6f210b12&scoped=true&"
import script from "./AllElderAge.vue?vue&type=script&lang=js&"
export * from "./AllElderAge.vue?vue&type=script&lang=js&"
import style0 from "./AllElderAge.vue?vue&type=style&index=0&id=6f210b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f210b12",
  null
  
)

export default component.exports